import { useState, useCallback, useMemo } from "react";
import { ArrowUp, ArrowDown } from "lucide-react";

const useSortedPagination = ({ initialSortBy = null, initialAscending = true, isColumnDisabled } = {}) => {
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [sort, setSort] = useState({ sortBy: initialSortBy, ascending: initialAscending });

  const toggleSort = useCallback((column) => {
    if (isColumnDisabled && isColumnDisabled(column)) return;
    setPage(1);
    setSort((current) =>
      current.sortBy === column
        ? { sortBy: column, ascending: !current.ascending }
        : { sortBy: column, ascending: false }
    );
  }, [isColumnDisabled]);

  const sortArrow = useCallback(
    (column) => {
      if (sort.sortBy !== column) return null;
      const Icon = sort.ascending ? ArrowUp : ArrowDown;
      return <Icon size={14} />;
    },
    [sort]
  );

  const goToPrevious = useCallback(() => setPage((p) => Math.max(1, p - 1)), []);
  const goToNext = useCallback(() => setPage((p) => p + 1), []);

  return useMemo(
    () => ({
      page,
      setPage,
      totalPages,
      setTotalPages,
      sortBy: sort.sortBy,
      ascending: sort.ascending,
      toggleSort,
      sortArrow,
      goToPrevious,
      goToNext,
    }),
    [page, totalPages, sort, toggleSort, sortArrow, goToPrevious, goToNext]
  );
};

export default useSortedPagination;
